import { useMemo } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../../assets/logo-2MAX-large.png";
import CommonFooter from "../../../components/CommonFooter";

import { cx } from "../../../react-helpers/css";
import SxForm from "../../../forms/SxForm";
import SxField from "../../../forms/fields/SxField";
import SubmitButton from "../../../components/SubmitButton";
import { object, string, boolean } from "yup";
import { authService } from "../../../services/auth/authService";
import SxCheckbox from "../../../forms/fields/SxCheckbox";
import { useTranslation } from "react-i18next";
import { toastsWithIntl } from "../../../services/toastService";

const RegisterTestPage = () => {
  const { requestTest } = authService();
  const { toastError, toastSuccess } = toastsWithIntl(["auth"]);
  const { t } = useTranslation(["auth", "subscription", "validation"]);

  const schema = useMemo(() => {
    return object({
      email: string()
        .email()
        .label(t("auth:test-request.labels.EMAIL"))
        .required(),
      tel: string().label(t("auth:test-request.labels.TEL")).required(),
      cguAccepted: boolean()
        .transform((v) => !!v)
        .oneOf([true]),
    });
  }, [t]);

  const initialValues = useMemo(() => {
    return {
      email: "",
      tel: "",
      cguAccepted: false,
    };
  }, []);

  return (
    <div className="auth-screen">
      <img src={Logo} alt="2 Minutes Max" className="logo" />
      <div className={cx(["auth-card", "--wide"])}>
        <div className="side-image" />

        <div className="card_body">
          {/* --- Accroche / Hero --- */}
          <div
            className="cblock --txt--center"
            style={{ maxWidth: 620, margin: "0 auto 28px" }}
          >
            <h1
              className="--txt--dark-blue"
              style={{
                fontSize: 28,
                lineHeight: 1.2,
                fontWeight: 800,
                margin: 0,
              }}
            >
              {t("auth:test-request.TITLE")}
              {/* Commencez à mieux sélectionner vos candidats
              <br />
              <span style={{ fontWeight: 800 }}>
                – 14&nbsp;jours gratuits&nbsp;!
              </span> */}
            </h1>

            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: "16px 0 0",
                display: "grid",
                gap: 8,
                justifyContent: "center",
              }}
              aria-label="Bénéfices de l'essai gratuit"
            >
              <li
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span role="img" aria-hidden>
                  ✅
                </span>
                <span>{t("auth:test-request.24_7_ACCESS")}</span>
              </li>
              <li
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span role="img" aria-hidden>
                  🔒
                </span>
                <span>{t("auth:test-request.NO_DEEPFAKE")}</span>
              </li>
            </ul>

            <p className="--txt--muted" style={{ margin: "16px 0 0" }}>
              {t("auth:test-request.DESCRIPTION")}
            </p>

            <div
              style={{
                display: "inline-block",
                marginTop: 12,
                padding: "6px 10px",
                borderRadius: 999,
                background: "rgba(16,185,129,.12)",
                border: "1px solid rgba(16,185,129,.35)",
                fontSize: 12,
                fontWeight: 600,
                color: "#065F46",
              }}
              aria-label="Accès complet sans carte bancaire"
            >
              {t("auth:test-request.NO_CARD_REQUIRED")}
            </div>
          </div>
          {/* --- /Accroche / Hero --- */}

          {/* Formulaire SxForm */}
          <SxForm
            initialValues={initialValues}
            validationSchema={() => schema} // ✅ évite l'erreur TS sur () => undefined
            onSubmit={async (values, helpers) => {
              try {
                await requestTest({ email: values.email, tel: values.tel });
                toastSuccess("auth:test-request.SUCCESS");
                helpers.resetForm();
              } catch {
                toastError("auth:test-request.ERROR");
              }
            }}
          >
            {(formik) => {
              const canSubmit =
                !!formik.values.email && formik.isValid && !formik.isSubmitting;

              return (
                <div
                  className="cblock"
                  style={{ maxWidth: 520, margin: "0 auto" }}
                >
                  {/* Email via SxField */}
                  <SxField name="email" placeholder="email@entreprise.com" />

                  {/* Tel via SxField */}
                  <SxField
                    name="tel"
                    placeholder={t("auth:register.placeholders.PHONE")}
                  />
                  <div
                    className="input-tip"
                    style={{ marginTop: 4, marginBottom: 12 }}
                  >
                    {t("auth:test-request.TEL_SUBTITLE")}
                  </div>

                  <div className="cblock">
                    <SxCheckbox
                      name="cguAccepted"
                      label={
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t("auth:register.ACCEPT_CGU"),
                          }}
                        />
                      }
                    />
                  </div>

                  {/* Submit */}
                  <div
                    className="lblock --txt--center"
                    style={{ marginTop: 20 }}
                  >
                    <SubmitButton
                      type="submit"
                      className="btn--1"
                      disabled={!canSubmit}
                    >
                      {t("auth:test-request.SUBMIT_BUTTON")}
                    </SubmitButton>
                  </div>
                  {/* CTA vers la connexion */}
                  <div
                    className="cblock --txt--center"
                    style={{ marginBottom: 24 }}
                  >
                    <span className="auth-cta">
                      {t("register.ALREADY_REGISTERED")}
                    </span>{" "}
                    <NavLink className="link" to={"/login"}>
                      {t("register.LOGIN")}
                    </NavLink>
                  </div>
                </div>
              );
            }}
          </SxForm>
        </div>
      </div>
      <CommonFooter />
    </div>
  );
};

export default RegisterTestPage;
